import { getStore } from '../store/store';
export default {
  store() {
    return getStore().getState();
  },
  SENTRY_DSN:
    'https://15843e47a4bb4be6abce6c3d907f757e@o222561.ingest.sentry.io/5368803',
};
